import { sortByKey } from 'utils/sortByKey'

export const getMultiSelectOptions = (data: { id: string | number; name: string }[]) => {
  return data.map((d) => ({ value: d.id, label: d.name })).sort(sortByKey('label'))
}
